import React from 'react';
import { useTranslation } from 'react-i18next';
import useTranslationLgs from '@hooks/i18n/useTranslation.tsx';
import { MenuItemModel, SubMenuItemModel } from '@components/menu/types.ts';
import CountryFlag from '@components/framework/CountryFlag/CountryFlag.tsx';

export const useLanguageMenuItem = (): MenuItemModel => {
  const { tr } = useTranslationLgs();
  const { i18n } = useTranslation();

  const languages = [
    { name: tr(`AppTopbar.czech`, `Czech`), code: 'cs', alpha3: 'CZE' },
    { name: tr('AppTopbar.english', 'English'), code: 'en', alpha3: 'GBR' },
    { name: tr('AppTopbar.german', 'Deutsch'), code: 'de', alpha3: 'DEU' },
    { name: tr('AppTopbar.hungarian', 'Hungrarian'), code: 'hu', alpha3: 'HUN' },
    { name: tr('AppTopbar.poland', 'Polish'), code: 'pl', alpha3: 'POL' },
    { name: tr('AppTopbar.french', 'French'), code: 'fr', alpha3: 'FRA' },
  ];

  const changeLanguage = (selectedLocale: string) => {
    const currentPath = window.location.pathname;
    const currentSearch = window.location.search;

    const languageCodes = languages.map(l => l.code);
    const pathParts = currentPath.split('/').filter(part => part);
    const hasLanguagePrefix = pathParts.length > 0 && languageCodes.includes(pathParts[0]);

    const newPath = hasLanguagePrefix ? currentPath.replace(/^\/[^/]+/, '/' + selectedLocale) : `/${selectedLocale}${currentPath}`;

    window.location.href = `${newPath}${currentSearch}`;
  };

  const selectedLang = languages.find(l => l.code === i18n.language);

  return {
    title: selectedLang?.name,
    icon: <CountryFlag code={selectedLang?.alpha3} alt={selectedLang?.name} className="h-auto w-6" />,
    mode: 'open-outside-bottom',
    subMenu: languages.map(
      lang =>
        ({
          title: (
            <div className={'flex flex-row gap-4'}>
              <CountryFlag code={lang.alpha3} alt={lang.name} className="h-auto w-6" />
              <div>{lang.name}</div>
            </div>
          ),
          onClick: () => {
            changeLanguage(lang.code);
          },
          active: false,
        } as SubMenuItemModel),
    ),
  } as MenuItemModel;
};